import PricesList from "../List/List";
import {gsap} from "gsap";
import PricesNavigation from "../Navigation/Navigation";
import PricesVehicle from "../Vehicle/Vehicle";
import TabTools from "../TabTools/TabTools";
import PricesTabTools from "../TabTools/TabTools";

const PricesTabs = {

    init() {
        this.el = $('[page="prices"][section="tabs"]');
        if (!this.el.length) return;

        // this.allowEditButton = this.el.find("button.allow-edit");
        // this.saveButton = this.el.find("button.save");
        this.navButton = this.el.find('[component="NavButton"]');
        this.nav = this.el.find('nav');
        // this.alert = this.el.find('.alert');

        this.viewType = this.el.find('.subTabs a');

        this.bind();
    },

    bind() {
        this.navButton.unbind('click').click((evt) => {
            const el = $(evt.currentTarget);

            if (!el.is('.open')) this.open();
            else this.close();
        });

        this.bindAdmin();
    },

    bindAdmin() {
        if (!Prices.isAdmin) {
            return;
        }

        this.viewType.on("click", PricesTabs.changeViewType);
    },

    open() {
        this.navButton.removeClass('closing').addClass('open');
        gsap.set(this.nav, {height: "auto", padding: 12});
        gsap.from(this.nav, {height: 0, padding: 0});
    },

    close() {
        this.navButton.removeClass('open').addClass('closing');
        gsap.to(this.nav, {height: 0, padding: 0, clearProps: true});
    },

    changeViewType() {
        const content = $('section.Prices');
        let type = $(this).data("class");

        $(this).parents().closest("ul").find("a.active").removeClass("active");
        $(this).addClass("active");

        content.removeAttr("view").attr("view", type);

        if (type === 'activeDiscounts') {
            if (PricesTabTools.allowEditButton.is(".active")) {
                PricesTabTools.allowEditButton.trigger("click");
            }
        }
    },
}

export default PricesTabs;